import React, { useState, createRef } from "react";
import styles from "styles/modules/ComponentCard.module.scss";

import { BoldText, NormalText } from "components/Texts";
import ImagePlaceHolder from "img/imagePlaceholder.svg";
import ImageSlectTick from "img/ImageSelectTickIcon.svg";
import ImageSelectTickDisabled from "img/ImageSelectTickDisabled.svg";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import OverlayPopOver from "Uitls/OverlayPopOver";
import { ToolTipText } from "components/TooltipText";
import { getMlrStatusIcon } from "Uitls/Util";

const ComponentCard = ({
  selectedComponent,
  componentObjet,
  onSelectComponent,
  selectedComponentId,
  isAlreadyAdded,
  isDisabled,
}) => {
  const { t } = useTranslation();
  const popoverRef = createRef();
  const isSelected = (componentId) => {
    const index = selectedComponentId.findIndex((item) => {
      return item === componentId;
    });
    return index > -1 ? styles.componentCardSelected : "";
  };
  const isComponentSelected = (componentId) => {
    const index = selectedComponentId.findIndex((item) => {
      return item === componentId;
    });
    return index > -1 ? true : false;
  };

  const getOverlayStyle = () => ({
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 10,
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(2px)",
  });

  return (
    <div
      className={`${styles.componentCardParent} ellipssesSingleLine`}
      ref={popoverRef}
    >
      <div
        title={`${
          isDisabled(componentObjet)
            ? "Selection disabled due to country or subtype mismatch"
            : isAlreadyAdded(componentObjet.componentDocNumber)
            ? t("module.alreadyAdded")
            : ""
        }`}
        className={`${styles.componentCard} ellipssesSingleLine 
    ${isSelected(componentObjet.componentDocNumber)} 
    ${
      isAlreadyAdded(componentObjet.componentDocNumber)
        ? styles.componentCardDisabled
        : ""
    }
    ${isDisabled(componentObjet) ? styles.componentCardDisabled : ""}
    ${
      selectedComponentId.length >= 3 &&
      !isSelected(componentObjet.componentDocNumber)
        ? styles.maxSelectionReached
        : ""
    }`}
        onClick={() => {
          if (
            isDisabled(componentObjet) ||
            isAlreadyAdded(componentObjet.componentDocNumber) ||
            (selectedComponentId.length >= 3 &&
              !isSelected(componentObjet.componentDocNumber))
          ) {
            return;
          }
          onSelectComponent(componentObjet.componentDocNumber);
        }}
      >
        {isComponentSelected(componentObjet.componentDocNumber) && (
          <img
            src={ImageSlectTick}
            alt=""
            className={`${styles.imageSelectionTick}`}
          ></img>
        )}
        {isAlreadyAdded(componentObjet.componentDocNumber) && (
          <img
            src={ImageSelectTickDisabled}
            alt=""
            className={`${styles.imageSelectionTick}`}
          ></img>
        )}

        <div
          className={`${styles.imageBlock}`}
          style={{
            backgroundImage: `url(${componentObjet.componentUrl})`,
            backgroundColor: componentObjet.componentUrl ? "transparent" : "",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
          }}
        >
          {isDisabled(componentObjet) && (
            <div className="cardOverLay-2" style={getOverlayStyle()}>
              <PreviewMessage>
                Global Data Graphics <br /> cannot be selected
              </PreviewMessage>
            </div>
          )}

          {componentObjet?.componentUrl ? (
            ""
          ) : (
            <img
              src={ImagePlaceHolder}
              alt="Placeholder"
              className="btnVhCenter"
            />
          )}
        </div>

        <div className={`d-block `} style={{ margin: "12px" }}>
          <div className="d-flex mb-6px">
            <NormalText>ID:</NormalText>{" "}
            <OverlayPopOver
              element={
                <img
                  src={getMlrStatusIcon(componentObjet.mlrStatus)}
                  alt={componentObjet.mlrStatus}
                  style={{
                    marginLeft: "4px",
                    marginRight: "2px",
                  }}
                />
              }
              overlayData={
                <ToolTipText>{componentObjet.mlrStatus}</ToolTipText>
              }
              trigger={["hover", "focus"]}
              placement="bottom"
              classId="tooltip"
              containerRef={popoverRef}
            />
            <BoldText
              fontWeight="bold"
              style={{ marginLeft: "2px" }}
              disabled={
                isAlreadyAdded(componentObjet.componentDocNumber) ||
                isDisabled(componentObjet)
              }
            >
              {componentObjet.componentDocNumber}
            </BoldText>{" "}
          </div>
          <div className="d-flex mb-6px">
            <NormalText>Name:</NormalText>{" "}
            <BoldText
              fontWeight="bold"
              style={{
                marginLeft: "2px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
              disabled={
                isAlreadyAdded(componentObjet.componentDocNumber) ||
                isDisabled(componentObjet)
              }
            >
              {componentObjet.componentName
                ? componentObjet.componentName
                : "-"}
            </BoldText>
          </div>
          <div className="d-flex">
            <NormalText>Primary Country:</NormalText>{" "}
            <BoldText
              fontWeight="bold"
              style={{
                marginLeft: "2px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
              disabled={
                isAlreadyAdded(componentObjet.componentDocNumber) ||
                isDisabled(componentObjet)
              }
            >
              {componentObjet.countryName ? componentObjet.countryName : "-"}
            </BoldText>
          </div>
        </div>
      </div>
    </div>
  );
};

const PreviewMessage = styled.div`
  font-size: 12px;
  color: white;
  text-align: center;
  padding: 10px;
`;

export default ComponentCard;
